//
// Copyright (c) 2011-2026 by Curalate, Inc.
//

import React from 'react';
import styled from 'styled-components';

import { ProductDetailsFieldLabels } from '@campaigns/components/shared/product-details-modal/drawer/constants/ProductDetailsModalFieldLabels';
import { BodyText } from '@components/atoms/text/Text';
import { DEFAULT_EMPTY_VALUE } from '@constants/DefaultEmptyValues';

interface ProductMetaFieldsViewOnlyProps {
  brand?: string;
  category?: string;
}

const getDisplayValue = (value?: string | null) =>
  value && value.trim() !== '' ? value : DEFAULT_EMPTY_VALUE;

export const ProductMetaFieldsViewOnly = ({
  brand,
  category,
}: ProductMetaFieldsViewOnlyProps) => {
  return (
    <Container>
      <FieldContainer>
        <BodyText>{ProductDetailsFieldLabels.brand}</BodyText>
        <BodyText>{getDisplayValue(brand)}</BodyText>
      </FieldContainer>
      <FieldContainer>
        <BodyText>{ProductDetailsFieldLabels.category}</BodyText>
        <BodyText>{getDisplayValue(category)}</BodyText>
      </FieldContainer>
    </Container>
  );
};

const Container = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${({ theme }) => theme.spacings[3]};
`;

const FieldContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${({ theme }) => theme.spacings[1]};
`;
